import https from './https'

// 登录
export function login(data){
    return https({
        url: '/sys/login',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 新增用户
export function addUser(data){
    return https({
        url: '/api/user/add-user',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 查找用户
export function queryUser(data){
    return https({
        url: '/api/user/query-user',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 更新用户
export function updateUser(data){
    return https({
        url: '/api/user/update-user',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 删除用户
export function delUser(data){
    return https({
        url: '/api/user/delete-user',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 修改密码
export function updatePwd(data){
    return https({
        url: '/api/user/update-password',
        method: 'POST',
        data
    })
}

// 退出登录
export function addDevice(data){
    return https({
        url: '/api/user/user-device-grant',
        method: 'POST',
        data,
        isRaw: true
    })
}

// 退出登录
export function loginOut(data){
    return https({
        url: '/sys/logout',
        method: 'POST',
        data
    })
}

// 获取公司
export function getCompany(data){
    return https({
        url: '/api/user/query-company',
        method: 'GET',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/user.js